export default __webpack_public_path__ + "fbb57686cd3571270fcd324daa43d13c.svg";